import { AfterViewInit, Directive, ElementRef, Input, OnChanges, Renderer2 } from '@angular/core';

const DISABLED = 'disabled';
const DISABLE_CHILDREN = 'disabled-children';
const TAB_INDEX = 'tabindex';
const TAG_ANCHOR = 'a';

@Directive({
  standalone: false,
  selector: '[disableChildren]'
})
export class DisableChildrenDirective implements OnChanges, AfterViewInit {

  @Input() disableChildren = true;

  constructor(private elemRef: ElementRef, private renderer: Renderer2) { }

  ngOnChanges() {
    this.disableElement(this.elemRef.nativeElement);
  }

  ngAfterViewInit() {
    this.disableElement(this.elemRef.nativeElement);
  }

  private disableElement(element) {
    if (this.disableChildren) {
      if (!element.hasAttribute(DISABLED)) {
        this.renderer.setAttribute(element, DISABLE_CHILDREN, '');
        this.renderer.setAttribute(element, DISABLED, 'true');

        // disabling anchor tab keyboard event
        if (element.tagName.toLowerCase() === TAG_ANCHOR) {
          this.renderer.setAttribute(element, TAB_INDEX, '-1');
        }
      }
    } else {
      if (element.hasAttribute(DISABLE_CHILDREN)) {
        if (element.getAttribute('disabled') !== '') {
          element.removeAttribute(DISABLED);
        }
        element.removeAttribute(DISABLE_CHILDREN);
        if (element.tagName.toLowerCase() === TAG_ANCHOR) {
          element.removeAttribute(TAB_INDEX);
        }
      }
    }
    if (element.children) {
      for (const ele of element.children) {
        this.disableElement(ele);
      }
    }
  }
}